import { AvailableLanguages } from "@cda-libs/cda-models";

export const DEFAULT_LANGUAGE: AvailableLanguages = "es";